function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconRoomDoorFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 4H8a1 1 0 00-1 1v23h14V5a1 1 0 00-1-1zM8 2a3 3 0 00-3 3v25h18V5a3 3 0 00-3-3H8z",
    fill: props.color
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28 30H2v-2h26v2z",
    fill: props.color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19 15.5a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0z",
    fill: props.color
  }));
}

export default SvgIconRoomDoorFilled;